import React from "react";
import { SocialMenu } from "./SocialMenu";
import { Copyright } from "./Copyright";

export class About extends React.Component {
  componentDidMount() {
    this.props.handleOverflow();
  }
  componentWillUnmount() {
    this.props.handleOverflow();
  }
  render() {
    let photoCollage = this.props.about.collage;
    let regex = /"htt(.*?)"/gm;
    let match = photoCollage.match(regex);
    let tile = match.map((src, index) => {
      return (
        <div
          key={index}
          style={{
            background: `url(${src})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center"
          }}
        />
      );
    });
    return (
    
<div className="about-wrap">
        <SocialMenu />
        <Copyright />
        <div className="about-lead">{this.props.about.lead}</div>
        <div className="about-photo-collage">{tile}</div>
        <div
          className="about-body"
          dangerouslySetInnerHTML={{ __html: this.props.about.body }}
        />
        <div className="about-clients">
          <div className="about-clients-label">Klienci:</div>
          <div
            className="about-clients-list-wrap"
            dangerouslySetInnerHTML={{ __html: this.props.about.clients }}
          />
        </div>
      </div>
      
    
    );
  }
}



// WEBPACK FOOTER //
// ./src/About.js